import { render } from "./student-all.vue?vue&type=template&id=4dafa0ce&ts=true"
import script from "./student-all.ts?vue&type=script&lang=ts&external"
export * from "./student-all.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__